"use client"

import { useEffect, useRef } from "react"

// Type declaration moved to AdSenseAd.tsx to avoid conflicts

interface StoryBodyAdsInitializerProps {
  children: React.ReactNode
}

export default function StoryBodyAdsInitializer({ children }: StoryBodyAdsInitializerProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    // Check if AdSense is loaded
    if (typeof window === "undefined" || !window.adsbygoogle) {
      //console.debug("AdSense not loaded, skipping ad initialization")
      return
    }

    // Find all <ins> elements with class "adsbygoogle" in the story body
    // Skip ads that have already been processed (data-adsbygoogle-status="done")
    const adElements = containerRef.current.querySelectorAll("ins.adsbygoogle:not([data-adsbygoogle-status='done'])")

    if (adElements.length === 0) {
      //console.debug("No AdSense elements found in story body")
      return
    }

    //console.debug(`Found ${adElements.length} AdSense elements in story body`)

    // Push to adsbygoogle for each ad element found
    adElements.forEach((element, index) => {
      const htmlElement = element as HTMLElement
      // Check if the element has an offset width (is visible)
      if (htmlElement.offsetWidth) {
        try {
          // Read the ad slot from the element's data attribute
          const adSlot = htmlElement.getAttribute("data-ad-slot")
          if (adSlot) {
            window.adsbygoogle.push({ google_ad_slot: adSlot })
            //console.debug(`Initialized AdSense ad ${index + 1} with slot ${adSlot}`)
          } else {
            console.warn(`AdSense element ${index + 1} missing data-ad-slot attribute`)
          }
        } catch (err) {
          console.debug("AdSense push error:", err)
        }
      } else {
        //console.debug(`Skipped hidden AdSense ad ${index + 1}`)
      }
    })
  }, []) // containerRef is stable and doesn't need to be a dependency

  return <div ref={containerRef}>{children}</div>
}
